// @flow
import styles from './JobDetailsPage.less';

import React, { Component } from 'react';
import classnames from 'classnames';
import { get } from 'lodash';

import {
  Card,
  Hidden,
  PageBlock,
  ScreenReaderSkipTarget,
  Section
} from 'seek-style-guide/react';

import CompanyReviewCard from './CompanyReviewCard/CompanyReviewCard';
import JobApply from './JobApply/JobApply';
import JobDescription from './JobDescription/JobDescription';
import JobMeta from './JobMeta/JobMeta';
import Lmis from 'src/components/Lmis/Lmis';
import StickyApplyMobile from './StickyApplyMobile/StickyApplyMobile';
import StickyHeader from './StickyHeader/StickyHeader';

type Props = {
  job: ChaliceJobDetail,
  location: UrlLocation,
  seekerId?: number,
  sessionId?: string
};

class JobDetailsPage extends Component<Props> {
  renderAside = () => {
    const { job } = this.props;

    const {
      companyReview,
      advertiser,
      hasCustomTemplate,
      isPrivateAdvertiser
    } = job;

    return (
      <aside
        className={
          hasCustomTemplate ? styles.flexGrow : styles.lockSideColumnWidth
        }
      >
        <Hidden print>
          <JobApply />
          <Hidden component={Card} mobile>
            <Section>
              <JobMeta job={job} />
            </Section>
          </Hidden>
          {!isPrivateAdvertiser && companyReview && (
            <CompanyReviewCard {...{ companyReview, advertiser }} />
          )}
          <Lmis />
        </Hidden>
      </aside>
    );
  };

  render() {
    const { job, location, seekerId, sessionId } = this.props;

    const { branding, hasCustomTemplate } = job;
    const coverImageUrl = get(branding, 'cover.url');
    const coverImageTitle = get(branding, 'cover.title');

    return (
      <div data-automation="job-detail-page">
        <StickyHeader {...job} />
        {branding && (
          <div
            role="img"
            alt={coverImageTitle}
            data-automation="brandingCoverImage"
            className={classnames({
              [styles.coverImagePlaceholder]: true,
              [styles.coverImage]: coverImageUrl
            })}
            style={{
              backgroundImage: coverImageUrl && `url(${coverImageUrl})`
            }}
          />
        )}
        <PageBlock>
          <ScreenReaderSkipTarget name="start-of-content" />
          <div
            className={classnames(styles.fixStyleGuideColumns, {
              [styles.wrapperTopSpacing]: !branding
            })}
          >
            <div
              className={
                hasCustomTemplate ? styles.lockDetailsWidth : styles.flexGrow
              }
            >
              <JobDescription {...{ job, location, seekerId, sessionId }} />
            </div>
            {this.renderAside()}
          </div>
        </PageBlock>
        <StickyApplyMobile />
      </div>
    );
  }
}

export default JobDetailsPage;
